module.exports = __webpack_public_path__ + "img/hello.206555c9.png";